/**
 * ModeSelector - Seletor de modo de exportação (Batch/Simple)
 */

import { MODAL_STYLES, EXPORT_MODES } from '../constants';
import type { ExportMode } from '../types';

interface ModeSelectorProps {
  value: ExportMode;
  onChange: (mode: ExportMode) => void;
  disabled?: boolean;
}

export function ModeSelector({ value, onChange, disabled }: ModeSelectorProps) {
  return (
    <div className="space-y-2">
      <label className="text-xs font-medium text-gray-300">Modo de exportação</label>
      
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as ExportMode)}
        disabled={disabled}
        className={MODAL_STYLES.select}
        aria-label="Selecionar modo de exportação"
      >
        {Object.entries(EXPORT_MODES).map(([key, label]) => (
          <option key={key} value={key}>
            {label}
          </option>
        ))}
      </select>
      
      <div className="text-xs text-gray-500">
        {value === 'batch' 
          ? 'Exporta cada objeto com nome individual' 
          : 'Exporta com template de nome automático'}
      </div>
    </div>
  );
}

